import type { ValueOf } from 'type-fest';

type Entry<T> = {
  key: string;
  props: T;
};

export const variants = {
  contained: 'contained',
  fullBleed: 'full-bleed',
} as const;

export type Carousel<T> = {
  description?: string;
  entries: Entry<T>[];
  id: string;
  labels: {
    next: string;
    previous: string;
  };
  title?: string;
  variant?: ValueOf<typeof variants>;
};
